import apiRequest from "../../utils/apiRequest";

/**
 * Services HTTP du domaine Consultation.
 *
 * <p>Contrat back :
 * <ul>
 *   <li>POST /consultation → 201 + Long (id).</li>
 *   <li>GET /consultation/{id} → ConsultationResponse.</li>
 *   <li>DELETE /consultation/{id} → 200/204 (void).</li>
 *   <li>GET /consultation/by-date?date=YYYY-MM-DD → List&lt;ConsultationResponse&gt;.</li>
 *   <li>GET /consultation/upcoming-appointment/{doctorId} → List&lt;AppointmentResponse&gt;.</li>
 *   <li>GET /consultation/by-patient/{patientId} → List&lt;ConsultationResponse&gt;
 *       (non paginé — réponse tableau plat).</li>
 *   <li>GET /consultation/prescription-card-pdf/{id} → PDF (binary).</li>
 *   <li>GET /consultation/glasses-prescription-card-pdf/{id} → PDF (binary).</li>
 * </ul>
 */

export const createConsultation = async (payload) => {
  return apiRequest.post("/consultation", payload);
};

export const getConsultationById = async (id) => {
  if (id == null) {
    return { ok: false, status: 0, message: "id manquant", error: "BadRequest" };
  }
  return apiRequest.get(`/consultation/${id}`);
};

export const deleteConsultation = async (id) => {
  if (id == null) {
    return { ok: false, status: 0, message: "id manquant", error: "BadRequest" };
  }
  return apiRequest.del(`/consultation/${id}`);
};

export const getConsultationsByDate = async (date) => {
  if (!date) {
    return { ok: false, status: 0, message: "date manquante", error: "BadRequest" };
  }
  return apiRequest.get(`/consultation/by-date?date=${encodeURIComponent(date)}`);
};

/**
 * Historique des consultations d'un patient (tableau plat, non paginé).
 *
 * @param {number} patientId
 */
export const getConsultationsByPatient = async (patientId) => {
  if (patientId == null) {
    return { ok: false, status: 0, message: "patientId manquant", error: "BadRequest" };
  }
  return apiRequest.get(`/consultation/by-patient/${patientId}`);
};

export const upcomingAppointments = async (doctorId) => {
  if (doctorId == null) {
    return { ok: false, status: 0, message: "doctorId manquant", error: "BadRequest" };
  }
  return apiRequest.get(`/consultation/upcoming-appointment/${doctorId}`);
};
